<template>
  <div class="left-tree">
    <div class="left-tree-title"><span></span><slot></slot></div>
    <el-tree
      ref="tree"
      :data="topicCategorys"
      :props="defaultProps"
      node-key="value"
      :defaultCheckedKeys="defaultCheckedProvince"
      accordion
      @node-click="handleNodeClick"
      >
    </el-tree>
  </div>
</template>

<script>
export default {
  name: 'TreeList',
  data () {
    return {
      defaultProps: {
        label: 'value'
      },
      defaultCheckedProvince: []
    }
  },
  props: {
    topicCategorys: Array
  },
  created () {
    this.defaultCheckedProvince = [this.$route.query.Province]
  },
  watch: {
    '$route.query.Province' () {
      this.$refs.tree.setCheckedKeys([this.$route.query.Province])
    }
  },
  methods: {
    async handleNodeClick(data) {
      if (await this.$loginAuthentication.intercept(0)) {
        this.$nextTick(() => {
          this.$router.push({ path: 'book', query: { Province: data.value, query: this.$route.query.query || '' } })
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.left-tree {
  float: left;
  background:#f4f4f4;
  .left-tree-title {
    height: 50px;
    border-bottom: 1px solid #DDDDDD;
    line-height: 50px;
    font-size: 16px;
    color: #333333;
    position: relative;
    width: 210px;
    margin: 0 auto;
    text-indent: 30px;
    span {
      &::before {
        content: "";
        position: absolute;
        height: 14px;
        width: 14px;
        background: url("../../assets/imgs/title-bg-top.png") no-repeat;
        left: 0;
        top: 18px;
      }
      &::after {
        content: "";
        position: absolute;
        height: 14px;
        width: 14px;
        background: url("../../assets/imgs/title-bg-top.png") no-repeat;
        top: 23px;
        left: 6px;
      }
    }
  }
  /deep/.el-tree {
    background:#f4f4f4;
    margin-top: 10px;
    .el-tree-node {
     .el-tree-node__content {
        text-align: center;
        height: 40px;
        line-height: 40px;
        display: block;
        color: #333;
        cursor: pointer;
        &:hover {
          background-color: #e4e4e4;
          color: #1743a5;
        }
        .el-icon-caret-right {
          display: none;
        }
       .el-tree-node__label {
         margin: 0 10px;
         &::before {
           content: '·';
           display: inline-block;
           color: transparent;
         }
         &::after {
           content: '·';
           display: inline-block;
           color: transparent;
         }
       }
     }
    }
    .is-checked {
      .el-tree-node__content {
        background: #4160a5;
        color: #fff;
        &::before {
          content: '·';
          display: inline-block;
          color: #fff;
         }
        &::after {
          content: '·';
          display: inline-block;
          color: #fff;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/treeList/TreeListBook.vue